module.exports = __webpack_public_path__ + "img/6_uk.b0548459.svg";